// extracted by mini-css-extract-plugin
module.exports = {"container":"FixedNumberField_container__gpHC-","comment":"FixedNumberField_comment__2Kb8p"};